import React from "react";
import { useLang } from "@/contexts/LanguageContext";
import AnimatedNumber from "@/components/AnimatedNumber";

/**
 * AnchorStat — anchors the hero promise with a real revenue number.
 * Designed to slot under the hero before metrics row.
 */
const AnchorStat = () => {
  const { lang } = useLang();
  return (
    <section
      data-testid="anchor-stat"
      className="relative border-y border-brand-border bg-brand-bg overflow-hidden"
    >
      <div className="aurora opacity-30 pointer-events-none" />
      <div className="relative mx-auto max-w-[1400px] px-6 lg:px-10 py-12 md:py-16 grid lg:grid-cols-12 gap-6 items-center">
        <div className="lg:col-span-7 flex items-baseline gap-4 flex-wrap">
          <span className="font-heading text-6xl md:text-8xl font-black tracking-tighter text-white leading-none">
            <AnimatedNumber value="2.4" />
            <span>M</span>
          </span>
          <span className="font-heading text-2xl md:text-3xl font-bold uppercase tracking-tight text-zinc-200">
            EUR
          </span>
          <span className="text-[11px] font-mono uppercase tracking-[0.25em] text-brand-purpleLight">
            /2025
          </span>
        </div>
        <p className="lg:col-span-5 text-base md:text-lg text-zinc-300 leading-relaxed">
          {lang === "bg"
            ? "Това е сборът от допълнителните приходи, които генерирахме за нашите клиенти само през 2025. Не визии, не impressions — реални пари."
            : "That's the additional revenue we generated for our clients in 2025 alone. Not impressions, not vibes — real money."}
        </p>
      </div>
    </section>
  );
};

export default AnchorStat;
